import { PricingRow } from './src/PricingRow';
import { PricingCard } from './src/PricingCard';
import { PricingCustom } from './src/PricingCustom';
import { Modal } from './src/Modal';

const PricingPlans = {};

PricingPlans.Row = PricingRow;
PricingPlans.Card = PricingCard;
PricingPlans.Custom = PricingCustom;
PricingPlans.Modal = Modal;

export { PricingPlans };
